<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog width="1200px" :value="value" @input="toggleModal()" persistent scrollable>
    <v-card color="kbLight">
      <v-toolbar :class="mainColor" dark flat>
        <div class="text-h6">
          {{ `${$t('general.import')} ${$t('general.people')}` }}
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleModal()">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-stepper class="elevation-0 transparent" v-model="importerStep">
          <ImporterNewHeaders
            :business-module="businessModule"
            :color="mainColor"
            :sidebar-modules="sidebarModules"
          />

          <v-stepper-content step="1">
            <v-form ref="importerList" v-model="valid" lazy-validation>
              <ImportationTypes
                :business-module="businessModule"
                :color="mainColor"
                :lists-persons="listsPersons"
                :sidebar-modules="sidebarModules"
                :type="type"
              />
            </v-form>
          </v-stepper-content>

          <v-stepper-content step="2">
            <UploadImportFile :color="mainColor" />
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-row>
              <v-col cols="12">
                <h3 class="text-center mb-5">
                  {{ $t('general.identifyImportedFields')}}
                </h3>
              </v-col>
            </v-row>

            <template v-if="importerSelection === 'negocio'">
              <ImportedFieldsIdentifier
                :color="mainColor"
                :importer-headers="importerHeaders"
                :importer-persons="importerPersons"
                :items="businessItems"
              />
            </template>

            <template v-else>
              <ImportedFieldsIdentifier
                v-for="(values, key) in items.classifiedItems"
                :key="key"
                :color="mainColor"
                custom-items
                :importer-headers="filteredImportedHeaders(values, key)"
                :importer-persons="importerPersons"
                :items="items.items"
                :section-title="$t(`general.${key}`)"
              />
            </template>

          </v-stepper-content>

          <v-stepper-content step="4">
            <ImportedItemsPreview
              :importer-headers="importerHeaders"
              :importer-persons="importerPersons"
            />
          </v-stepper-content>

          <v-stepper-content step="5">
            <SetImportationResponsible v-model="responsibleId" />
          </v-stepper-content>
        </v-stepper>
      </v-card-text>

      <v-card-actions class="d-flex justify-space-between align-center">
        <v-btn outlined
               color="error"
               @click="toggleModal()"
               v-show="importerStep === 1">{{ $t('general.cancel') }}</v-btn>

        <v-btn v-show="importerStep > 1"
               :color="mainColor"
               outlined
               @click="back()">
          {{ $t('general.goBack') }}
        </v-btn>
        <v-btn :color="mainColor"
               dark
               @click="continueImport()"
               :loading="loading"
               v-show="!(importerStep === 2 && importerFile === null)">
          {{ $t('general.continue') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Libraries
import XLSX from 'xlsx'
import { mapState, mapGetters } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'

// Components
import ImportedFieldsIdentifier from '@/components/ui/ImporterNew/ImportedFieldsIdentifier'
import ImporterNewHeaders from '@/components/ui/ImporterNew/ImporterNewHeaders'
import ImportationTypes from '@/components/ui/ImporterNew/ImportationTypes'
import UploadImportFile from '@/components/ui/ImporterNew/UploadImportFile'
import ImportedItemsPreview from '@/components/ui/ImporterNew/ImportedItemsPreview'
import SetImportationResponsible from '@/components/ui/ImporterNew/SetImportationResponsible'

export default {
  created () {
    this.$store.dispatch('getListsPersons')
  },
  components: {
    SetImportationResponsible,
    ImportedItemsPreview,
    ImportedFieldsIdentifier,
    ImportationTypes,
    ImporterNewHeaders,
    UploadImportFile
  },
  computed: {
    ...mapGetters(['token', 'businessModule']),
    ...mapState({
      appCustomExtradatas: state => state.apps.appCustomExtradatas,
      listsPersons: state => state.listsPersons.listsPersons
    }),
    importerFile: {
      get () {
        return this.$store.state.listsPersons.importer.file
      },
      set (value) {
        this.$store.commit('SET_IMPORTER_FILE', value)
      }
    },
    importerHeaders: {
      get () {
        let importerHeaders = this.$store.state.listsPersons.importer.headers
        if (importerHeaders && Array.isArray(importerHeaders)) {
          importerHeaders = importerHeaders.sort((a, b) => (a.newText > b.newText) ? 1 : -1)
        }
        return importerHeaders || []
      },
      set (value) {
        this.$store.commit('SET_IMPORTER_HEADERS', value)
      }
    },
    importerListId: {
      get () {
        return this.$store.state.listsPersons.importer.listId
      },
      set (value) {
        this.$store.commit('SET_IMPORTER_LIST_ID', value)
      }
    },
    importerListName: {
      get () {
        return this.$store.state.listsPersons.importer.listName
      },
      set (value) {
        this.$store.commit('SET_IMPORTER_LIST_NAME', value)
      }
    },
    importerSelection: {
      get () {
        return this.$store.state.listsPersons.importer.importerSelection
      },
      set (value) {
        this.$store.commit('SET_IMPORTER_SELECTION', value)
      }
    },
    importerNewList: {
      get () {
        return this.$store.state.listsPersons.importer.newList
      },
      set (value) {
        this.$store.commit('SET_IMPORTER_NEW_LIST', value)
      }
    },
    importerPersons: {
      get () {
        return this.$store.state.listsPersons.importer.persons
      },
      set (value) {
        this.$store.commit('SET_IMPORTER_PERSONS', value)
      }
    },
    importerStep: {
      get () {
        return this.$store.state.listsPersons.importer.step
      },
      set (value) {
        this.$store.commit('SET_IMPORTER_STEP', value)
      }
    },
    items () {
      const otherField = { text: this.$t('general.other'), value: 'other' }

      const businessInformationItems = [
        { text: this.businessModule.s, value: 'business' },
        { text: this.$t('general.businessRoles'), value: 'businessroles' }
      ]

      const personalInformationItems = [
        { text: this.$t('general.firstName'), value: 'name' },
        { text: this.$t('general.lastName'), value: 'lastname' },
        { text: this.$t('general.email'), value: 'email' },
        { text: this.$t('general.phone'), value: 'phone' },
        { text: this.$t('general.roles'), value: 'userroles' }
      ]

      let items = [...businessInformationItems, ...personalInformationItems]

      let extraDataItems = []

      if (this.appCustomExtradatas && Array.isArray(this.appCustomExtradatas)) {
        const itemsValues = items.map(item => item.value.toLowerCase())

        extraDataItems = this.appCustomExtradatas.filter(item => itemsValues.indexOf(item.name.toLowerCase()) === -1)
        extraDataItems = extraDataItems.map(item => {
          return {
            text: item.name,
            value: item.name.toLowerCase()
          }
        })

        items = [...items, ...extraDataItems]
      }
      businessInformationItems.push(otherField)
      extraDataItems.push(otherField)
      items.push(otherField)
      personalInformationItems.push(otherField)

      return {
        classifiedItems: { personalInformationItems, businessInformationItems, extraDataItems },
        items
      }
    },
    businessItems () {
      return [
        { text: this.$t('general.categories'), value: 'categories' },
        { text: this.$t('general.contact'), value: 'contact' },
        { text: this.$t('general.company'), value: 'company' },
        { text: this.$t('general.address'), value: 'address' },
        { text: this.$t('general.document'), value: 'document' },
        { text: 'Email', value: 'email' },
        { text: this.$t('general.image'), value: 'image' },
        { text: this.$t('general.location'), value: 'location' },
        { text: this.$t('general.observation'), value: 'observation' },
        { text: this.$t('general.position'), value: 'position' },
        { text: this.$t('general.phone'), value: 'phone' },
        { text: 'URL', value: 'url' }
      ]
    },
    sidebarModules () {
      return this.$store.getters.sidebarModules
    }
  },
  data () {
    return {
      isImportationTypesFormValid: false,
      loading: false,
      result: [],
      rules,
      responsibleId: '',
      search: '',
      valid: false
    }
  },
  methods: {
    back () {
      if (this.importerStep === 2) {
        this.importerStep = 1
        return
      }
      if (this.importerStep === 3) {
        this.importerStep = 2
        return
      }

      if (this.importerStep === 4) {
        this.importerStep = 3
        return
      }

      if (this.importerStep === 5) {
        this.importerStep = 4
      }
    },
    continueImport () {
      if (this.importerStep === 1) {
        if (!this.importerSelection) return notifications.error(this.$t('general.pickWhereToSavePeopleToImport'))
        if (!this.$refs.importerList.validate()) return
        this.importerStep = 2
        return
      }
      if (this.importerStep === 2) {
        this.importerStep = 3
        this.processFile()
        return
      }

      if (this.importerStep === 3) {
        this.importerStep = 4
        return
      }

      if (this.importerStep === 4) {
        this.importerStep = 5
        return
      }

      if (this.importerStep === 5) {
        this.submit()
      }
    },
    filteredImportedHeaders (classifiedItems, key) {
      const { items } = this.items
      const itemsValues = items.map(item => item.value)
      const classifiedItemsValues = classifiedItems.map(item => item.value)
      return this.importerHeaders.filter(item => {
        return classifiedItemsValues.includes(item.newText) ||
          (key === 'extraDataItems' && !itemsValues.includes(item.newText))
      })
    },
    submit () {
      this.loading = true

      if (this.importerSelection === 'negocio') {
        this.importBusiness()
      } else if (this.importerSelection === 'nueva') {
        this.createNewList()
      } else if (this.importerSelection === 'existente') {
        this.importPersons()
      } else if (this.importerSelection === 'sin-lista') {
        this.importPersons()
      }
    },
    createNewList () {
      this.$store.dispatch('createList', { listName: this.importerListName }).then(response => {
        this.importerListId = response._id
        this.loading = false
        this.importPersons('list', this.responsibleId)
      }).catch(error => {
        notifications.error(error.message)
        this.loading = false
      })
    },
    async importBusiness () {
      try {
        await this.$store.dispatch('importBusiness')
        this.loading = false
        this.toggleModal()
      } catch (error) {
        notifications.error(error.message)
        this.loading = false
      }
    },
    importPersons () {
      this.$store.dispatch('importNew', { importType: this.importType, responsibleId: this.responsibleId }).then(response => {
        if (response.success) {
          this.loading = false
          this.toggleModal()
        }
      }).catch(error => {
        this.loading = false
        notifications.error(error.message)
      })
    },
    getHeaderRow (sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r /* start in the first row */

      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })] /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C // <-- replace with your desired default

        if (this.importerSelection === 'negocio') {
          if (cell && cell.t) hdr = XLSX.utils.format_cell(cell).toLowerCase()
        } else {
          if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        }

        headers.push(hdr)
      }
      return headers
    },
    mapHeaderAutomatically (header) {
      const headerObject = { text: header, value: header, newText: header.toLowerCase(), otherText: '' }
      if (header && typeof header === 'string') {
        if (header.toLowerCase() === 'first name') headerObject.newText = 'name'
        else if (header.toLowerCase() === 'last name') headerObject.newText = 'lastname'
        return headerObject
      }
      return headerObject
    },
    readWorkbook (data) {
      return new Promise((resolve) => {
        const workbook = XLSX.read(data, { type: 'binary', sheetRows: 5 })
        resolve(workbook)
      })
    },
    processFile () {
      if (this.importerFile) {
        const reader = new FileReader()
        reader.readAsBinaryString(this.importerFile)
        reader.onload = event => {
          const data = event.target.result
          this.readWorkbook(data).then(workbook => {
            const firstSheetName = workbook.SheetNames[0]
            const worksheet = workbook.Sheets[firstSheetName]
            const result = {
              headers: this.getHeaderRow(worksheet),
              data: XLSX.utils.sheet_to_json(worksheet)
            }

            if (this.importerSelection === 'negocio') {
              if (Array.isArray(result.data) && result.data.length > 0) {
                result.data.forEach((row, index) => {
                  for (const key in row) {
                    row[key.toLowerCase()] = row[key]
                  }
                })
              }
            }

            this.processResult(result)
          })
        }

        reader.onerror = function () {
          notifications.error(this.$t('general.errorReadingTheFile'))
        }
      }
    },
    processResult (result) {
      this.importerHeaders = []
      result.headers.forEach(header => {
        // Changing first name to name in order to map First name automatically
        const headerObject = this.mapHeaderAutomatically(header)
        this.importerHeaders.push(headerObject)
      })

      this.$store.commit('SET_IMPORTER_PERSONS', result.data)
    },
    toggleModal () {
      this.$store.commit('RESET_IMPORTER_PROGRESS')
      this.result = []
      this.$emit('input', false)
    }
  },
  props: {
    importType: {
      default: 'lists',
      type: String
    },
    value: Boolean,
    type: String,
    mainColor: {
      type: String,
      default: 'kbPink'
    }
  }
}
</script>
